import { assert, IGNORED, Test } from "oc-e2e-testrunner";
import { assertWarnungen, resetArrangement } from "./utils";
import * as Debugs from "oc-threejs/Debugs";

export default {
  name: "TestElementhöhen",
};

export const testLichtleisteBodenabstandVerringern: Test = async () => {
  // Element 2630 wurde durch 3685 in den Metadaten ersetzt (Maße 183cm -> 184cm)
  resetArrangement(true);
  const agt = APP.arrangement;
  const configuiration = {
    inspiration: "Inspiration SYSTEM WPC PLATINUM XL Taupe-Grau",
    zaunart: "Sichtschutz",
    serie: "SYSTEM",
    grundriss: {
      ecken: [
        {
          id: 3,
          punkt: {
            x: -1.5,
            y: 0,
          },
        },
        {
          id: 695,
          punkt: {
            x: 14,
            y: 0,
          },
        },
      ],
      kanten: [
        {
          ecken: [3, 695],
        },
      ],
    },
    segmente: [
      {
        breite: 15.5,
        partsAndPfosten: [
          {
            type: "Element",
            breite: 1.6822,
            höhe: 1.845,
            snap: -1,
            isBreiteKonfigurierbar: true,
            x0: 0.02,
            füllungAuswahlwert: "SYSTEM WPC PLATINUM XL Taupe-Grau",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "3574_Montageplatten Anthrazit",
            abschlussleisteAuswahlwert: "Abschlussleisten Silber",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile30cm_ZaunSets",
            profilAuswahlwert: "Dekor Gamma Edelstahl/hoch",
            profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "180x180_Easy",
            profilPosition: 5,
            showProfil: null,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            elementNr: 0,
            isStandardMass: false,
            detailSerie: "SYSTEM WPC PLATINUM XL",
            anMauer: "AnMauer_nein",
            isMasselement: false,
            isMassProfil: false,
            isBestellseite: false,
            elementID: 0,
          },
          {
            type: "Pfosten",
            x0: 1.6822,
            pfostenfarbeAuswahlwert: "Anthrazit",
            pfostenfarbeAuswahlwertIndividualisiert: false,
            bodenbefestigungAuswahlwert: "Einbetoniert im Boden",
            bodenbefestigungAuswahlwertIndividualisiert: false,
            elementhalterAuswahlwertIndividualisiert: false,
            pfostenartAuswahlwert: "Klemmpfosten",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            pfostenkappeAuswahlwert: "Pfostenkappe_inklusiv",
            ankerInnen: false,
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 1.6822,
            höhe: 1.845,
            snap: -1,
            isBreiteKonfigurierbar: true,
            x0: 1.7422,
            füllungAuswahlwert: "SYSTEM WPC PLATINUM XL Taupe-Grau",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "3574_Montageplatten Anthrazit",
            abschlussleisteAuswahlwert: "Abschlussleisten Silber",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Lichtleiste_Steckzaun",
            profilAuswahlwert: "SYSTEM_Lichtleiste_Steckzaun",
            profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "180x180_Easy",
            profilPosition: 6,
            showProfil: true,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            elementNr: 1,
            isStandardMass: false,
            detailSerie: "SYSTEM WPC PLATINUM XL",
            anMauer: "AnMauer_nein",
            isMasselement: false,
            isBestellseite: false,
            elementID: 0,
          },
          {
            type: "Pfosten",
            x0: 3.4044,
            pfostenfarbeAuswahlwert: "Anthrazit",
            pfostenfarbeAuswahlwertIndividualisiert: false,
            bodenbefestigungAuswahlwert: "Einbetoniert im Boden",
            bodenbefestigungAuswahlwertIndividualisiert: false,
            elementhalterAuswahlwertIndividualisiert: false,
            pfostenartAuswahlwert: "Klemmpfosten",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            pfostenkappeAuswahlwert: "Pfostenkappe_inklusiv",
            ankerInnen: false,
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 1.6922,
            höhe: 1.8,
            snap: -1,
            isBreiteKonfigurierbar: true,
            x0: 3.4594,
            füllungAuswahlwert: "SYSTEM Rhombus Bambus",
            füllungAuswahlwertIndividualisiert: true,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "3574_Montageplatten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile_30cm_Zaunfeld_Rhombus",
            profilAuswahlwert: "Dekor Gamma Edelstahl/hoch",
            profilleisteAuswahlwert: "Dekor_Adapter_Rhombus_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "180x180_Easy",
            profilPosition: 24,
            showProfil: null,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            elementNr: 2,
            isStandardMass: false,
            detailSerie: "SYSTEM RHOMBUS",
            anMauer: "AnMauer_nein",
            isMasselement: false,
            isMassProfil: false,
            isBestellseite: false,
            elementID: 0,
          },
          {
            type: "Pfosten",
            x0: 5.1266,
            pfostenfarbeAuswahlwert: "Anthrazit",
            pfostenfarbeAuswahlwertIndividualisiert: false,
            bodenbefestigungAuswahlwert: "Einbetoniert im Boden",
            bodenbefestigungAuswahlwertIndividualisiert: false,
            elementhalterAuswahlwertIndividualisiert: false,
            pfostenartAuswahlwert: "Klemmpfosten",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            pfostenkappeAuswahlwert: "Pfostenkappe_inklusiv",
            ankerInnen: false,
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 1.6922,
            höhe: 1.8,
            snap: -1,
            isBreiteKonfigurierbar: true,
            x0: 5.1816,
            füllungAuswahlwert: "SYSTEM Rhombus Bambus",
            füllungAuswahlwertIndividualisiert: true,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "3574_Montageplatten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Lichtleiste_Rhombus",
            profilAuswahlwert: "SYSTEM_Lichtleiste_Rhombus_Bambus",
            profilleisteAuswahlwert: "Dekor_Adapter_Rhombus_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "180x180_Easy",
            profilPosition: 30,
            showProfil: true,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            elementNr: 3,
            isStandardMass: false,
            detailSerie: "SYSTEM RHOMBUS",
            anMauer: "AnMauer_nein",
            isMasselement: false,
            isBestellseite: false,
            elementID: 0,
          },
          {
            type: "Pfosten",
            x0: 6.8488,
            pfostenfarbeAuswahlwert: "Anthrazit",
            pfostenfarbeAuswahlwertIndividualisiert: false,
            bodenbefestigungAuswahlwert: "Einbetoniert im Boden",
            bodenbefestigungAuswahlwertIndividualisiert: false,
            elementhalterAuswahlwertIndividualisiert: false,
            pfostenartAuswahlwert: "Klemmpfosten",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            pfostenkappeAuswahlwert: "Pfostenkappe_inklusiv",
            ankerInnen: false,
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 1.6822,
            höhe: 1.845,
            snap: -1,
            isBreiteKonfigurierbar: true,
            x0: 6.9088,
            füllungAuswahlwert: "SYSTEM NEO HOLZ Thermoholz",
            füllungAuswahlwertIndividualisiert: true,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "3574_Montageplatten Anthrazit",
            abschlussleisteAuswahlwert: "Abschlussleisten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile_30cm_Zaunfeld_NEO_Holz",
            profilAuswahlwert: "Dekor Gamma Edelstahl/hoch",
            profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "180x180_Easy",
            profilPosition: 5,
            showProfil: null,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            elementNr: 4,
            isStandardMass: false,
            detailSerie: "SYSTEM NEO HOLZ",
            anMauer: "AnMauer_nein",
            isMasselement: false,
            isMassProfil: false,
            isBestellseite: false,
            elementID: 0,
          },
          {
            type: "Pfosten",
            x0: 8.571,
            pfostenfarbeAuswahlwert: "Anthrazit",
            pfostenfarbeAuswahlwertIndividualisiert: false,
            bodenbefestigungAuswahlwert: "Einbetoniert im Boden",
            bodenbefestigungAuswahlwertIndividualisiert: false,
            elementhalterAuswahlwertIndividualisiert: false,
            pfostenartAuswahlwert: "Klemmpfosten",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            pfostenkappeAuswahlwert: "Pfostenkappe_inklusiv",
            ankerInnen: false,
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 1.6822,
            höhe: 1.845,
            snap: -1,
            isBreiteKonfigurierbar: true,
            x0: 8.631,
            füllungAuswahlwert: "SYSTEM NEO HOLZ Thermoholz",
            füllungAuswahlwertIndividualisiert: true,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "3574_Montageplatten Anthrazit",
            abschlussleisteAuswahlwert: "Abschlussleisten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Lichtleiste_Steckzaun",
            profilAuswahlwert: "SYSTEM_Lichtleiste_Steckzaun",
            profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "180x180_Easy",
            profilPosition: 17,
            showProfil: true,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            elementNr: 5,
            isStandardMass: false,
            detailSerie: "SYSTEM NEO HOLZ",
            anMauer: "AnMauer_nein",
            isMasselement: false,
            isBestellseite: false,
            elementID: 0,
          },
          {
            type: "Pfosten",
            x0: 10.2932,
            pfostenfarbeAuswahlwert: "Anthrazit",
            pfostenfarbeAuswahlwertIndividualisiert: false,
            bodenbefestigungAuswahlwert: "Einbetoniert im Boden",
            bodenbefestigungAuswahlwertIndividualisiert: false,
            elementhalterAuswahlwertIndividualisiert: false,
            pfostenartAuswahlwert: "Klemmpfosten",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            pfostenkappeAuswahlwert: "Pfostenkappe_inklusiv",
            ankerInnen: false,
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 1.6922,
            höhe: 1.8,
            snap: -1,
            isBreiteKonfigurierbar: true,
            x0: 10.3482,
            füllungAuswahlwert: "SYSTEM Rhombus Silber",
            füllungAuswahlwertIndividualisiert: true,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "3574_Montageplatten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile_30cm_Zaunfeld_Rhombus",
            profilAuswahlwert: "Dekor Gamma Edelstahl/hoch",
            profilleisteAuswahlwert: "Dekor_Adapter_Rhombus_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "180x180_Easy",
            profilPosition: 24,
            showProfil: null,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            elementNr: 6,
            isStandardMass: false,
            detailSerie: "SYSTEM RHOMBUS",
            anMauer: "AnMauer_nein",
            isMasselement: false,
            isMassProfil: false,
            isBestellseite: false,
            elementID: 0,
          },
          {
            type: "Pfosten",
            x0: 12.0154,
            pfostenfarbeAuswahlwert: "Anthrazit",
            pfostenfarbeAuswahlwertIndividualisiert: false,
            bodenbefestigungAuswahlwert: "Einbetoniert im Boden",
            bodenbefestigungAuswahlwertIndividualisiert: false,
            elementhalterAuswahlwertIndividualisiert: false,
            pfostenartAuswahlwert: "Klemmpfosten",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            pfostenkappeAuswahlwert: "Pfostenkappe_inklusiv",
            ankerInnen: false,
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 1.6922,
            höhe: 1.8,
            snap: -1,
            isBreiteKonfigurierbar: true,
            x0: 12.0704,
            füllungAuswahlwert: "SYSTEM Rhombus Silber",
            füllungAuswahlwertIndividualisiert: true,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "3574_Montageplatten Anthrazit",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Lichtleiste_Rhombus",
            profilAuswahlwert: "SYSTEM_Lichtleiste_Rhombus_Lärche",
            profilleisteAuswahlwert: "Dekor_Adapter_Rhombus_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "180x180_Easy",
            profilPosition: 28,
            showProfil: true,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            elementNr: 7,
            isStandardMass: false,
            detailSerie: "SYSTEM RHOMBUS",
            anMauer: "AnMauer_nein",
            isMasselement: false,
            isBestellseite: false,
            elementID: 0,
          },
          {
            type: "Pfosten",
            x0: 13.7376,
            pfostenfarbeAuswahlwert: "Anthrazit",
            pfostenfarbeAuswahlwertIndividualisiert: false,
            bodenbefestigungAuswahlwert: "Einbetoniert im Boden",
            bodenbefestigungAuswahlwertIndividualisiert: false,
            elementhalterAuswahlwertIndividualisiert: false,
            pfostenartAuswahlwert: "Klemmpfosten",
            verbundankerAuswahlwert: "Verbundanker-Set_mit",
            ummantelungAuswahlwert: "Ummantelung_ohne",
            pfostenkappeAuswahlwert: "Pfostenkappe_inklusiv",
            ankerInnen: false,
            ausgleichGefälle: false,
          },
          {
            type: "Element",
            breite: 1.6822,
            höhe: 1.845,
            snap: -1,
            isBreiteKonfigurierbar: true,
            x0: 13.7976,
            füllungAuswahlwert: "SYSTEM WPC PLATINUM XL Taupe-Grau",
            füllungAuswahlwertIndividualisiert: false,
            gehflügelAuswahlwert: "Gehflügel_links",
            drückerAuswahlwert: "Drücker_Knauf_edelstahl",
            profilzylinderAuswahlwert: "Profilzylinder_mit",
            öffnungAuswahlwert: "Öffnung_nach_innen",
            anschlagAuswahlwert: "Anschlag_links",
            schieberichtungAuswahlwert: "Schieberichtung_links",
            schiebetormotorseiteAuswahlwert: "Schiebetormotorseite_A",
            füllungsseiteAuswahlwert: "Füllungsseite_B",
            anschlagprofilAuswahlwert: "Tor_an_Mauer_Anschlagsprofil_180cm",
            anschlagprofilfarbeAuswahlwert: "3574_Montageplatten Anthrazit",
            abschlussleisteAuswahlwert: "Abschlussleisten Silber",
            abschlussleisteAuswahlwertIndividualisiert: false,
            profilKategorieAuswahlwert: "Dekorprofile30cm_ZaunSets",
            profilAuswahlwert: "Dekor Gamma Edelstahl/hoch",
            profilleisteAuswahlwert: "Dekor_Adapter_anthrazit",
            zubehörAnzahl: {
              Handsender: 0,
              "Handsender Design": 0,
              Schlüsselschalter: 0,
              "Funk-Codeschloss": 0,
              "Bluetooth Schalter": 0,
              "Connect Gateway": 0,
              Lichtschranke: 0,
              "Techniker Key": 0,
            },
            toröffnerAuswahlwert: "Toröffner_ohne",
            torschließerAuswahlwert: "Torschließer_ohne",
            form: "Rechteck",
            massAuswahlwert: "180x180_Easy",
            profilPosition: 5,
            showProfil: null,
            anschlussAufRechts: false,
            gehflügelbreite: 0,
            standflügelbreite: 0,
            torIstFertig: false,
            elementNr: 8,
            isStandardMass: false,
            detailSerie: "SYSTEM WPC PLATINUM XL",
            anMauer: "AnMauer_nein",
            isMasselement: false,
            isMassProfil: false,
            isBestellseite: false,
            elementID: 0,
          },
        ],
        verteilungsstrategieAuswahlwert: "Individuell",
      },
    ],
    ecken: [
      {
        position: {
          x: -1.5,
          y: 0,
          z: 0,
        },
        pfosten: {
          type: "Pfosten",
          position: {
            x: -1.5,
            y: 0,
            z: 0,
          },
          pfostenfarbeAuswahlwert: "Anthrazit",
          pfostenfarbeAuswahlwertIndividualisiert: false,
          bodenbefestigungAuswahlwert: "Einbetoniert im Boden",
          bodenbefestigungAuswahlwertIndividualisiert: false,
          elementhalterAuswahlwertIndividualisiert: false,
          pfostenartAuswahlwert: "Klemmpfosten",
          verbundankerAuswahlwert: "Verbundanker-Set_mit",
          ummantelungAuswahlwert: "Ummantelung_ohne",
          pfostenkappeAuswahlwert: "Pfostenkappe_inklusiv",
          ankerInnen: false,
          ausgleichGefälle: false,
        },
      },
      {
        position: {
          x: 14,
          y: 0,
          z: 0,
        },
        pfosten: {
          type: "Pfosten",
          position: {
            x: 14,
            y: 0,
            z: 0,
          },
          pfostenfarbeAuswahlwert: "Anthrazit",
          pfostenfarbeAuswahlwertIndividualisiert: false,
          bodenbefestigungAuswahlwert: "Einbetoniert im Boden",
          bodenbefestigungAuswahlwertIndividualisiert: false,
          elementhalterAuswahlwertIndividualisiert: false,
          pfostenartAuswahlwert: "Klemmpfosten",
          verbundankerAuswahlwert: "Verbundanker-Set_mit",
          ummantelungAuswahlwert: "Ummantelung_ohne",
          pfostenkappeAuswahlwert: "Pfostenkappe_inklusiv",
          ankerInnen: false,
          ausgleichGefälle: false,
        },
      },
    ],
    aufbauten: [
      {
        Key: "xuu6cyqtuba",
        aufbauMeta: "Trafo",
        position: {
          x: 0.22222222222222232,
          y: 0,
          z: 0.3500000000000004,
        },
        size: {
          x: 0.1,
          y: 0.1,
          z: 0.3,
        },
        drehung: 0,
      },
    ],
    lichtleistenSplitter: 0,
    lichtleistenZubehör: {
      "Edelstahl-Blende_Lichtleiste_Steckzaun": 0,
      "3834 SYSTEM Licht Smart Control Set": 1,
      "3836 SYSTEM Licht Fernbedienung": 0,
      "3835 SYSTEM Licht Bewegungsmelder": 0,
      "3837 SYSTEM Licht Steuerungsadapter": 0,
      "3838 SYSTEM Licht Kabel Zusatz-Steuerungsadapter": 0,
    },
    pfostenartAuswahlwert: "Klemmpfosten",
    pfostenfarbeAuswahlwert: "Anthrazit",
    bodenbefestigungAuswahlwert: "Einbetoniert im Boden",
    elementhalterAuswahlwert: "2096 Elementhalter",
    verteilungsstrategieAuswahlwert: "Individuell",
    bestellliste: [
      {
        ArtikelID: "2645",
        Anzahl: 2,
        AnzahlEditiert: false,
        JacoIds: [6, 7],
      },
      {
        ArtikelID: "2937",
        Anzahl: 2,
        AnzahlEditiert: false,
        JacoIds: [2, 3],
      },
      {
        ArtikelID: "3800",
        Anzahl: 2,
        AnzahlEditiert: false,
        JacoIds: [4, 5],
      },
      {
        ArtikelID: "2630",
        Anzahl: 3,
        AnzahlEditiert: false,
        JacoIds: [0, 1, 8],
      },
      {
        ArtikelID: "2341",
        Anzahl: 10,
        AnzahlEditiert: false,
        JacoIds: [],
      },
      {
        ArtikelID: "2314",
        Anzahl: 10,
        AnzahlEditiert: false,
        JacoIds: [],
      },
      {
        ArtikelID: "1398",
        Anzahl: 1,
        AnzahlEditiert: false,
        JacoIds: [],
      },
      {
        ArtikelID: "287",
        Anzahl: 2,
        AnzahlEditiert: false,
        JacoIds: [4, 5],
      },
      {
        ArtikelID: "3819",
        Anzahl: 2,
        AnzahlEditiert: false,
        JacoIds: [1, 5],
      },
      {
        ArtikelID: "3830",
        Anzahl: 1,
        AnzahlEditiert: false,
        JacoIds: [7],
      },
      {
        ArtikelID: "3829",
        Anzahl: 1,
        AnzahlEditiert: false,
        JacoIds: [3],
      },
      {
        ArtikelID: "3820",
        Anzahl: 1,
        AnzahlEditiert: false,
        JacoIds: [],
      },
      {
        ArtikelID: "3822",
        Anzahl: 1,
        AnzahlEditiert: false,
        JacoIds: [],
      },
      {
        ArtikelID: "3834",
        Anzahl: 1,
        AnzahlEditiert: false,
        JacoIds: [],
      },
    ],
    customAnzahlen: {},
    gesamtpreis: 5198.55,
    baugruppen: [
      [
        {
          ArtikelID: "2630",
          Anzahl: 2,
          MassOrBauseitsTag: "bauseits",
        },
      ],
      [
        {
          ArtikelID: "2630",
          Anzahl: 1,
          MassOrBauseitsTag: "bauseits",
        },
        {
          ArtikelID: "3819",
          Anzahl: 1,
          MassOrBauseitsTag: "bauseits",
        },
      ],
      [
        {
          ArtikelID: "2937",
          Anzahl: 1,
          MassOrBauseitsTag: "bauseits",
        },
      ],
      [
        {
          ArtikelID: "2937",
          Anzahl: 1,
          MassOrBauseitsTag: "bauseits",
        },
        {
          ArtikelID: "3829",
          Anzahl: 1,
          MassOrBauseitsTag: "bauseits",
        },
      ],
      [
        {
          ArtikelID: "3800",
          Anzahl: 1,
          MassOrBauseitsTag: "bauseits",
        },
        {
          ArtikelID: "287",
          Anzahl: 1,
          MassOrBauseitsTag: "bauseits",
        },
      ],
      [
        {
          ArtikelID: "3800",
          Anzahl: 1,
          MassOrBauseitsTag: "bauseits",
        },
        {
          ArtikelID: "3819",
          Anzahl: 1,
          MassOrBauseitsTag: "bauseits",
        },
        {
          ArtikelID: "287",
          Anzahl: 1,
          MassOrBauseitsTag: "bauseits",
        },
      ],
      [
        {
          ArtikelID: "2645",
          Anzahl: 1,
          MassOrBauseitsTag: "bauseits",
        },
      ],
      [
        {
          ArtikelID: "2645",
          Anzahl: 1,
          MassOrBauseitsTag: "bauseits",
        },
        {
          ArtikelID: "3830",
          Anzahl: 1,
          MassOrBauseitsTag: "bauseits",
        },
      ],
      [
        {
          ArtikelID: "2341",
          Anzahl: 10,
          MassOrBauseitsTag: "",
        },
        {
          ArtikelID: "2314",
          Anzahl: 10,
          MassOrBauseitsTag: "",
        },
        {
          ArtikelID: "1398",
          Anzahl: 1,
          MassOrBauseitsTag: "",
        },
      ],
    ],
    warnungen: [],
    montageanleitungenArtikelIDs: ["2341", "3819"],
    inspirationsBilder: [
      "/Artikel/system-wpc-platinum-xl-grau.jpg",
      "/Artikel/system-rhombus-bambus-51.jpg",
      "/Auswahlwert/system-neo-holz-51.jpg",
      "/Artikel/system-rhombus-silber-51.jpg",
    ],
    pageName: "Zauneditor",
    userDefinedArticles: [],
    hinweistexte: ["Füllungsseite_B"],
    zauneditorVisited: true,
  };
  agt.arrangement.fromJSON(configuiration);
  agt.update3d();
  const actual = Debugs.roundValues(
    agt.getElemente().map((e) => ({
      meta: e.meta.Key,
      lichtleisten: e.anzahlLichtleisten,
      physicalHeight: e.flügel[0].füllung.physicalHeight,
    })),
    3
  );
  assert.deepEquals(
    [
      {
        meta: "3685 SYSTEM WPC PLATINUM XL Taupe-Grau/Anthrazit Zaunfeld-Set 178 x 184 cm",
        lichtleisten: 0,
        physicalHeight: 1.859,
      },
      {
        meta: "3685 SYSTEM WPC PLATINUM XL Taupe-Grau/Anthrazit Zaunfeld-Set 178 x 184 cm",
        lichtleisten: 1,
        physicalHeight: 1.887,
      },
      {
        meta: "2937 SYSTEM RHOMBUS Bambus 180 x 180 cm",
        lichtleisten: 0,
        physicalHeight: 1.799,
      },
      {
        meta: "2937 SYSTEM RHOMBUS Bambus 180 x 180 cm",
        lichtleisten: 1,
        physicalHeight: 1.8,
      },
      {
        meta: "3800 SYSTEM NEO Holz Thermo Zaunfeld-Set 178 x 184 cm",
        lichtleisten: 0,
        physicalHeight: 1.865,
      },
      {
        meta: "3800 SYSTEM NEO Holz Thermo Zaunfeld-Set 178 x 184 cm",
        lichtleisten: 1,
        physicalHeight: 1.893,
      },
      {
        meta: "2645 SYSTEM RHOMBUS Silber 180 x 180 cm",
        lichtleisten: 0,
        physicalHeight: 1.799,
      },
      {
        meta: "2645 SYSTEM RHOMBUS Silber 180 x 180 cm",
        lichtleisten: 1,
        physicalHeight: 1.8,
      },
      {
        meta: "3685 SYSTEM WPC PLATINUM XL Taupe-Grau/Anthrazit Zaunfeld-Set 178 x 184 cm",
        lichtleisten: 0,
        physicalHeight: 1.859,
      },
    ],
    actual
  );
  assertWarnungen(agt, []);
};
